import { Fragment } from "react";
import { Form, Input, Button, Row, Col, Card, Typography, message } from "antd";
import { useMutation } from "react-query";
import Logo from "../../../assets/images/logo.png";
import { clear } from "../../../helpers/localStorage";
import { useParams, useNavigate } from "react-router-dom";
import { setPassword } from "../../../services/auth.services";
import "./SetPassword.css";

const { Title } = Typography;

const SetPassword = () => {
  const query = useParams();
  const navigate = useNavigate();

  const onSuccess = () => {
    clear();
    message.success("Password set successfully");
    navigate({ pathname: "/" });
  };

  const onError = (error) => {
    message.error(error?.response?.data?.message || "Something went wrong. Please try again.");
  };

  const { mutate } = useMutation(setPassword, {
    onError,
    onSuccess,
  });

  const onFinish = (values) => {
    const data = { ...values, token: query && query.token };
    mutate(data);
  };

  return (
    <Fragment>
      <Row type="flex" justify="center" align="middle" className="login">
        <Col
          lg={{ span: 8, offset: 8 }}
          md={{ span: 12, offset: 6 }}
          sm={{ span: 20, offset: 2 }}
          xs={{ span: 20, offset: 2 }}
          style={{ marginLeft: 0 }}
        >
          <Card
            bordered={false}
            style={{ padding: "20px 20px 10px 20px", borderRadius: "6px" }}
          >
            <div style={{ textAlign: "center" }}>
              <img src={Logo} style={{ width: "250px", height: "auto" }} alt="logo" />

              <Title level={4} type="secondary" style={{ marginTop: "25px" }}>
                Set Your Password
              </Title>
            </div>
            <Form name="setpassword" onFinish={onFinish}>
              <Form.Item
                name="new_password"
                rules={[
                  {
                    required: true,
                    message:
                      "Use 8 or more characters with a mix of letters, numbers & symbols.",
                    pattern: new RegExp(
                      "^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$"
                    ),
                  },
                ]}
              >
                <Input.Password
                  autoFocus={true}
                  placeholder="New Password"
                  size="large"
                  type="password"
                />
              </Form.Item>
              <Form.Item
                name="new_password_confirm"
                rules={[
                  { required: true, message: "Please input your Password!" },
                  ({ getFieldValue }) => ({
                    validator(rule, value) {
                      if (!value || getFieldValue("new_password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        "The new passwords that you entered do not match!"
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  type="password"
                  placeholder="Confirm Password"
                  size="large"
                />
              </Form.Item>

              <Form.Item>
                <Button
                  size="large"
                  type="primary"
                  htmlType="submit"
                  block
                  className="login-form-button"
                >
                  <span>Submit</span>
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};
export default SetPassword;
